import React from 'react';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import AdminPage from '../hocs/AdminPage';
import TenantLink from '../TenantLink';

const db = firebase.firestore();

export default AdminPage(function AdminBulkEmailHistory(props) {
  const {
    match: {
      params: { historyId },
    },
  } = props;

  const emailHistory = useDocumentSubscription(
    db.collection('bulkEmailHistories').doc(historyId),
    [historyId]
  );

  const recipients = emailHistory?.recipients || [];

  return (
    emailHistory != null && (
      <div>
        <div className="admin-bulk-email-history container-fluid py-5 position-relative">
          <div className="d-flex justify-content-center mb-3">
            <h4>一括メール送信履歴</h4>
          </div>
          <div className="bg-white p-4">
            <div className="mb-4">
              <div className="card">
                <div className="card-body">
                  <h6 className="card-title">送信情報</h6>
                  <div className="row">
                    <div className="col-md-6">
                      <p><strong>送信日時:</strong> {emailHistory.createdAt.toDate().toLocaleString()}</p>
                      <p><strong>送信者:</strong> {emailHistory.createdBy?.displayName}</p>
                    </div>
                    <div className="col-md-6">
                      <p><strong>件名:</strong> {emailHistory.subject}</p>
                      <p><strong>送信件数:</strong> {emailHistory.sentCount}件</p>
                    </div>
                  </div>
                  <div className="mt-3">
                    <p><strong>本文:</strong></p>
                    <div className="p-3 bg-light" style={{ whiteSpace: 'pre-line' }}>
                      {emailHistory.text}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <h6>送信対象者一覧 ({recipients.length}件)</h6>
            </div>
            {recipients.length > 0 ? (
              <table className="table">
                <thead className="thead-light text-center">
                  <tr>
                    <th style={{ minWidth: 100 }}>アカウント</th>
                    <th style={{ minWidth: 100 }}>メールアドレス</th>
                  </tr>
                </thead>
                <tbody>
                  {recipients.map((recipient, i) => (
                    <tr key={i}>
                      <td>
                        {recipient.uid ? (
                          <TenantLink to={`/admin/users/${recipient.uid}`}>{recipient.name}</TenantLink>
                        ) : (
                          recipient.name
                        )}
                      </td>
                      <td>{recipient.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div>送信対象者の情報がありません</div>
            )}
          </div>
        </div>
      </div>
    )
  );
});
